import gql from 'graphql-tag';

export default gql`
  mutation ForgotPassword($email: EmailAddress!) {
    forgotPassword(email: $email)
  }
`;
